import type { JiraProjectsHelpCenterMappingStatus } from './__generated__/manageProjects_GetProjectsQuery.graphql';

// oxlint-disable-next-line no-shadow
export enum ProjectsMappingStatus {
    UNLINKED = 'UNLINKED',
    LINKED = 'LINKED',
    ALL = 'ALL',
}

// oxlint-disable-next-line no-shadow
export enum ProjectsMappingMode {
    BULK = 'bulk',
    SINGLE = 'single',
}

// oxlint-disable-next-line no-shadow
export enum ProjectsMappingOperations {
    UNLINK = 'UNMAP_PROJECTS',
    LINK = 'MAP_PROJECTS',
}

export type StatusTextMap = {
    [key in Partial<JiraProjectsHelpCenterMappingStatus>]?: string;
};
